<template>
    <div class="email-parts">
        <b-card class="inner-page p-3 form-sample" :title="$translate('customer_email_parts')"
            :sub-title="$translate('customer_email_parts_note')">
            <b-overlay :show="updating" rounded="sm">
                <b-card-body>
                    <label for="input-domain" id="fieldset-domain" class="my-3"><strong>{{ $translate('email_domain')
                    }}</strong></label>
                    <b-form-input id="input-domain" v-model="formData.emailDomain">
                    </b-form-input>
                    <label for="input-suffix" id="fieldset-suffix" class="my-3"><strong>{{ $translate('dummy_suffix')
                    }}</strong></label>

                    <b-form-input id="input-suffix" v-model="formData.usernameSuffix">
                    </b-form-input>

                    <div class="text-center">
                        <button variant="primary" class="btn btn btn-info btn-fw mt-3 me-2 btn-primary"
                            v-if="hasPermissionUpdate" @click="updateSettings" size="sm">
                            <b-spinner small v-if="updating" :label="$translate('loading')"></b-spinner>
                            <span v-else>{{ $updateLabel() }}</span>
                        </button>
                    </div>
                </b-card-body>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'emailParts',
    mixins: [popupMixins, permissionsMixins],

    data: () => ({
        formData: {
            emailDomain: null,
            usernameSuffix: null,
        },
        updating: false,
    }),

    computed: {
        componentName() { return this.$translate('email_settings') },
        emailPartsValue() {
            return this.$store.getters['company/emailPartsValue']
        },

        emailPartsKey() {
            return this.$store.state.company.settingKeys.emailPartsKey
        },
    },

    watch: {
        emailPartsValue: {
            handler: function (val) {
                console.log('watch emailPartsValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.emailPartsKey
        )
        this.$nextTick(() => {
            this.updateModel(this.emailPartsValue)
        })
    },

    methods: {
        updateModel(emailPartsValue) {
            console.log('emailPartsValue:', emailPartsValue)
            const value = { ...(emailPartsValue || {}) }
            this.$set(this.formData, 'emailDomain', value.emailDomain)
            this.$set(this.formData, 'usernameSuffix', value.usernameSuffix)
        },
        async updateSettings() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false
                const value = { ...(this.formData || {}) }

                if (value.usernameSuffix && !this.$escapeSpecialCharRule.test(value.usernameSuffix)) {
                    throw Error(this.$translate('username_suffix_caption_regex_alert'))
                }
                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.emailPartsKey,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`)


            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
